module.exports = __webpack_public_path__ + "media/images/static/common/bg_connect_b-08d907dd57642d07db76e3f344771875.png";